import { Button } from '@liveauctioneers/hammer-ui-core/button';
import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import { H6 } from '@liveauctioneers/hammer-ui-core/text';
import { useCallback } from 'react';
import styled from 'styled-components';

import { RouteLink } from '@/components/RouteLinks/RouteLinks';
import { useAppDispatch } from '@/redux/hooks';
import { setSearchExclusion } from '@/redux/modules/search/exclusions/searchExclusions.actions';
import { getPreferencesUrl } from '@/utils/urls';

interface MobileExcludeConfirmProps {
    onConfirmExclusion: () => void;
    optionId: string | number;
    optionName: string;
}

const MobileExcludeConfirm = ({ onConfirmExclusion, optionId, optionName }: MobileExcludeConfirmProps) => {
    const dispatch = useAppDispatch();

    const handleCancelExclusion = useCallback(() => {
        onConfirmExclusion();
    }, [onConfirmExclusion]);

    const handleConfirmExclusion = useCallback(async () => {
        await dispatch(
            setSearchExclusion({
                exclude: false,
                facetId: 'auctionHouse',
                optionId: Number(optionId),
            })
        );
        onConfirmExclusion();
    }, [dispatch, onConfirmExclusion, optionId]);

    return (
        <MobileExcludeWrapper>
            <ExcludeMessageWrapper>
                <FormattedMessage
                    id="exclude_house_confirmation"
                    values={{
                        link: (
                            <RouteLink
                                className="inline"
                                key="mobile-exclude-confirm-link"
                                to={getPreferencesUrl()}
                            >
                                <FormattedMessage
                                    id="account_settings"
                                    key="mobile-exclude-confirm-link-message"
                                />
                            </RouteLink>
                        ),
                        name: (
                            <H6
                                className="inline"
                                key="mobile-exclude-confirm-name"
                            >
                                {optionName}
                            </H6>
                        ),
                    }}
                />
            </ExcludeMessageWrapper>

            <div className="flex justify-center space-x-md">
                <Button
                    className="w-[160px]"
                    onClick={handleConfirmExclusion}
                    size="sm"
                >
                    <FormattedMessage id="confirm" />
                </Button>
                <Button
                    className="w-[160px]"
                    onClick={handleCancelExclusion}
                    size="sm"
                    variant="outlined"
                >
                    <FormattedMessage id="cancel" />
                </Button>
            </div>
        </MobileExcludeWrapper>
    );
};

export default MobileExcludeConfirm;

const MobileExcludeWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: 32px 0;
`;

const ExcludeMessageWrapper = styled.div`
    display: block;
    margin-bottom: 32px;
`;
